import {createStore} from 'vuex';

export default new createStore({
    state: {
        action: '',
        modal: {},
        modalstatus: 'none',
        url: '',
        geocodeurl: '',
        destinationsurl: '',
        spapurl: '',
        assetsurl: '',
        producturl: '',
        notifyurl: '',
        datepickercssurl: '',
        geoname: '',
        datepickerpresetsrange: {},
        translations : {},
        icons: {},
        totelements: -1,
        elements: [],
        elementsfirstpage: {},
        geocodes: [],
        destinations: [],
        //minDate: 0,
        //maxDate: 0,
        breakpoints: null,
        numgeocodes: 5, //Numero di risultati visibili dei geocodes
        filters: {},
        filtersActive: {},
        filtersToApply: [],
        paginationOrderActive: {record_per_pagina:500}, // default record_per_pagina: '15' in init()
        totPage: 0, //Salviamo il numero dell'ultima pagina, vale anche come totale pagine
        searchResultsCount: 0,
        isFiltersColOpen: false,
        assets: {},
        selectedCity: '',
        alerts: []
    },
    mutations: {
        SET_MODAL: (state, data) => {
            state.modal = data;
        },
        SET_MODAL_STATUS: (state, data) => {
            state.modalstatus = data;
        },
        SET_URI: (state, uri) => {
            state.url = uri[0];
            state.geocodeurl = uri[1];
            state.destinationsurl = uri[2];
            state.spapurl = uri[3];
            state.assetsurl = uri[4];
            state.producturl = uri[5];
            state.notifyurl = uri[6];
        },
        SET_DATEPICKER_CSS_URL: (state, url) => {
            state.datepickercssurl = url;
        },
        SET_TOTELEMENTS: (state, totelements) => {
            state.totelements = totelements;
        },
        SET_ELEMENTS: (state, elements) => {
            state.elements = elements;
        },
        SET_GEOCODES: (state, geocodes) => {
            state.geocodes = geocodes;
        },
        SET_DESTINATIONS: (state, destinations) => {
            state.destinations = destinations;
        },
        SET_ASSETS: (state, assets) => {
            state.assets = assets;
        },
        SET_SELECTED_CITY: (state, selectedCity) => {
            state.selectedCity = selectedCity;
        },
        SET_TRANS: (state, trans) => {
            state.translations = trans;
        },
        SET_ICONS: (state, icons) => {
            state.icons = icons;
        },
        /*SET_MINMAXDATES: (state, minmax) => {
            state[minmax[0]] = minmax[1];
        },*/
        SET_PAGINATION: (state, paging) => {
            state.paginationOrderActive.pagina = paging[0];
            state.totPage = paging[1];
        },
        SET_FILTERS: (state, filters) => {
            state.filters = filters;
        },
        SET_FILTERS_TO_APPLY: (state, filters) => {
            state.filtersToApply = filters;
        },
        SET_FILTERS_COL_STATUS: (state, status) => {
            state.isFiltersColOpen = status;
        },
        SET_GEONAME: (state, geoname) => {
            state.geoname = geoname;
        },
        SET_ACTION: (state, action) => {
            state.action = action;
        },
        SET_ELEMENTS_FIRSTPAGE: (state, elementsfirstpage) => {
            state.elementsfirstpage = elementsfirstpage;
        },
        SET_DATEPICKER_RANGE_PRESETS: (state, presetsrange) => {
            state.datepickerpresetsrange = presetsrange;
        },
        SET_INFO_BREAKPOINTS: (state, breakpoints) => {
            state.breakpoints = breakpoints;
        },
        SET_ACTIVE_FILTERS: (state, filters) => {
            state.filtersActive = filters;
        },
        SET_ACTIVE_PAGINATION_ORDER: (state, pageorder) => {
            state.paginationOrderActive = pageorder;
        },
        SET_ALERTS: (state, alerts) => {
            state.alerts = alerts;
        }
    },
    actions: {
        setModal: (context, data) => {
            context.commit('SET_MODAL', data);
        },
        setModalStatus: (context, data) => {
            context.commit('SET_MODAL_STATUS', data);
        },
        setElements: (context, elements) => {
            context.commit('SET_ELEMENTS', elements);
        },
        setElementsFirstPage: (context, elementsfirstpage) => {
            context.commit('SET_ELEMENTS_FIRSTPAGE', elementsfirstpage);
        },
        setFilters: (context, filters) => {
            context.commit('SET_FILTERS', filters);
        },
        setGeocodes: (context, geocodes) => {
            context.commit('SET_GEOCODES', geocodes);
        },
        setGeoname: (context, geoname) => {
            context.commit('SET_GEONAME', geoname);
        },
        setDestinations: (context, destinations) => {
            context.commit('SET_DESTINATIONS', destinations);
        },
        setAssets: (context, assets) => {
            context.commit('SET_ASSETS', assets);
        },
        setSelectedCity: (context, city) => {
            context.commit('SET_SELECTED_CITY', city);
        },
        setTrans: (context, trans) => {
            context.commit('SET_TRANS', trans);
        },
        setIcons: (context, icons) => {
            context.commit('SET_ICONS', icons);
        },
        setAlerts: (context, alert) => {
            var alerts = JSON.parse(JSON.stringify(context.state.alerts));
            if (alerts.indexOf(alert)!=-1) {
                alerts.splice(alerts.indexOf(alert),1);
            }else{
                alerts.push(alert);
            }
            context.commit('SET_ALERTS', alerts);
        },
        setActiveFilters: (context, filtersActive) => {
            context.commit('SET_ACTIVE_FILTERS', filtersActive);
        },
        setActivePaginationOrder: (context, pageordersActive) => {
            context.commit('SET_ACTIVE_PAGINATION_ORDER', pageordersActive);
        },
        setFiltersColStatus: (context, status) => {
            context.commit('SET_FILTERS_COL_STATUS', status);
        },
        setInfoBreakpoints: (context, breakpoints) => {
            context.commit('SET_INFO_BREAKPOINTS', breakpoints);
        },
        setApplyFilter: (context, filter) => {
            var categoryFiltersOrigin = JSON.parse(JSON.stringify(context.state.filtersActive));
            var paginationOrderOrigin = JSON.parse(JSON.stringify(context.state.paginationOrderActive));
            var pagina = true;

            
            if(filter[2]==='filter') {
                if (Object.keys(categoryFiltersOrigin).length) {
                    var categoryFilters = categoryFiltersOrigin;
                    if (filter[0]==='date') {
                        if(categoryFilters.data_da === filter[1].data_da && categoryFilters.data_a === filter[1].data_a) {
                            //console.log("data_cancellare",filter);
                            delete categoryFilters.data_da;
                            delete categoryFilters.data_a;
                        }else{
                            //console.log("data_applicare",filter);
                            categoryFilters.data_da = filter[1].data_da;
                            categoryFilters.data_a = filter[1].data_a;
                        }
                    }
                    else if(filter[0] === 'nome_viaggio' || filter[0] === 'aree' || filter[0] === 'nazioni' || filter[0] === 'citta'){
                        var preval= categoryFilters[filter[0]];
                        delete categoryFilters['nome_viaggio'];
                        delete categoryFilters['aree'];
                        delete categoryFilters['nazioni'];
                        delete categoryFilters['citta'];
                        if (preval !== filter[1])
                            categoryFilters[filter[0]] = filter[1];
                    }
                    else if (categoryFilters[filter[0]]) {
                        categoryFilters[filter[0]].indexOf(filter[1]) == -1 ? categoryFilters[filter[0]].push(filter[1]) : categoryFilters[filter[0]].splice(categoryFilters[filter[0]].indexOf(filter[1]), 1);
                        if (categoryFilters[filter[0]].length == 0)
                            delete categoryFilters[filter[0]];
                    } else {
                        categoryFilters[filter[0]] = [filter[1]];
                    }
                } else {
                    categoryFilters = {};
                    if(filter[0]==='date'){
                        categoryFilters.data_da = filter[1].data_da;
                        categoryFilters.data_a = filter[1].data_a;
                    }else if (filter[0] === 'nome_viaggio' || filter[0] === 'aree' || filter[0] === 'nazioni' || filter[0] === 'citta') {
                        categoryFilters[filter[0]] = filter[1];
                    }
                    else{
                        categoryFilters[filter[0]] = [filter[1]];
                    }
                }
                context.commit('SET_ACTIVE_FILTERS', categoryFilters);
                pagina = true; //Se cambia un filtro riparto dalla pagina 0 per evitare bug di ritrovarsi in una pagina che non è più esistente per un numero elementi più alto
            } else {
                if (Object.keys(paginationOrderOrigin).length) {
                    var paginationOrder = paginationOrderOrigin;
                    if(filter[0]==='ordinamento'){
                        if(paginationOrder[filter[0]]){
                            paginationOrder[filter[0]] = paginationOrder[filter[0]].indexOf(filter[1]+'desc') == -1 ? filter[1]+'desc' : filter[1]+'asc';
                        }else{
                            paginationOrder[filter[0]] = filter[1]+'desc';
                        }
                    }else {
                        paginationOrder[filter[0]] = filter[1];
                    }
                    context.commit('SET_ACTIVE_PAGINATION_ORDER', paginationOrder);
                    if(filter[0] == 'record_per_pagina' || filter[2] == 'paginationorder-reset') //Se cambia record_per_pagina riparto dalla pagina 0 per evitare bug di ritrovarsi in una pagina che non è più esistente per un numero elementi più alto
                        pagina = true;
                }
            }

            if(!filter[3]){
                if(filter[2]=='paginationorder-persistent')
                    context.dispatch('exeFilters', { paginaReset: pagina, persistentEl: true });
                else
                    context.dispatch('exeFilters', { paginaReset: pagina });
            }else{
                if(filter[2]==='filter'){
                    var filtersToApply = JSON.parse(JSON.stringify(context.state.filtersToApply));
                    if(filter[0]==='date'){
                        if(filtersToApply.indexOf('date='+filter[1].data_da+'a'+filter[1].data_a) == -1){
                            filtersToApply.push('date='+filter[1].data_da+'a'+filter[1].data_a);
                        }else{
                            filtersToApply.splice(filtersToApply.indexOf('date='+filter[1].data_da+'a'+filter[1].data_a));
                        }
                    }else if(filtersToApply.indexOf(filter[0] + '=' + filter[1]) == -1) {
                        filtersToApply.push(filter[0]+'='+filter[1]);
                    }
                    else{
                        filtersToApply.splice(filtersToApply.indexOf(filter[0]+'='+filter[1]),1);
                    }
                    context.commit('SET_FILTERS_TO_APPLY', filtersToApply ? filtersToApply : []);

                }
            }
        },
        exeFilters: (context, config) => {
            var categoryFiltersOrigin = JSON.parse(JSON.stringify(context.state.filtersActive));
            var paginationOrderOrigin = JSON.parse(JSON.stringify(context.state.paginationOrderActive));
            var filtersCompleted = Object.assign(categoryFiltersOrigin, paginationOrderOrigin);
            filtersCompleted.id_geoname = context.state.geoname;
            if(config.paginaReset) {
                filtersCompleted.pagina = 0;
            }
            if(config.persistentEl){
                context.dispatch('getResponseAPI', {url:'data', action:'filters' , param: filtersCompleted, persistent: true});
            }else
                context.dispatch('getResponseAPI', {url:'data', action:'filters' , param: filtersCompleted});
        },
        removeFilters: (context, e) => {
            var paginationOrderOrigin = JSON.parse(JSON.stringify(context.state.paginationOrderActive));
            paginationOrderOrigin.id_geoname = context.state.geoname;
            context.dispatch('getResponseAPI', {url:'data', action:'removefilters' , param: paginationOrderOrigin});
        },
        setURI: (context, uri) => {
            context.commit('SET_URI', uri);
        },
        setDatepicker: (context, datepickerconfig) => {
            context.commit('SET_DATEPICKER_CSS_URL', datepickerconfig[0]);
            context.commit('SET_DATEPICKER_RANGE_PRESETS', JSON.parse(datepickerconfig[1]));
        },
        getResponseAPI: (context, config) => {
            //console.log(config.param);
            //console.log($.param(config.param));
            //console.log($.param(config.param).replace(/%5B/g, '').replace(/%5D/g, ''))
            var param = config.param && !config.method ? $.param(config.param).replace(/%5B/g, '').replace(/%5D/g, '') : config.param;
            $.ajax({
                url: config.url == 'data' ? context.state.url : config.url == 'geocode' ? context.state.geocodeurl : config.url == 'destinations' ? context.state.destinationsurl : config.url == 'notify' ? context.state.notifyurl : context.state.assetsurl,
                method: config.method ? config.method : 'GET',
                data: param,
                success: (response) => {
                    context.commit('SET_ACTION', config.action ? config.action : '');
                    if(config.url == 'data') {

                        if (config.action == 'init') {
                            context.commit('SET_GEONAME', config.param.id_geoname);
                            if(response.data.elementi){
                                context.commit('SET_ELEMENTS_FIRSTPAGE', { geoname: config.param.id_geoname, elements: response.data.elementi});
                            }
                            //context.dispatch('exeFilters', { paginaReset: true, persistentEl: true });
                        } else if (config.action == 'removefilters') {
                            context.commit('SET_ACTIVE_FILTERS', {});
                        }
                        context.commit('SET_FILTERS', response.data.filtri && response.data.filtri != '' ? response.data.filtri : {});
                        
                        var elements = [];

                        if(response.data.elementi) {
                            elements = response.data.elementi;
                            if (config.persistent) {
                                var elementsOrigin = JSON.parse(JSON.stringify(context.state.elements));
                                elements = elementsOrigin.concat(elements);
                            }
                        }
                        context.commit('SET_ELEMENTS', elements);

                        context.commit('SET_FILTERS_TO_APPLY', []);
                        context.commit('SET_TOTELEMENTS', response.data.totaleElementi ? response.data.totaleElementi : 0 );
                        context.commit('SET_PAGINATION', [response.data.pagina, response.data.totalePagine]);
                        /*if(response.data.elementi.length){
                            var maxDate = response.data.elementi.reduce(function(a, b){return Math.max(typeof a === 'number'? a : a.data_partenza_timestamp, b.data_partenza_timestamp)});
                            var minDate = response.data.elementi.reduce(function(a, b){return Math.min(typeof a === 'number'? a : a.data_partenza_timestamp, b.data_partenza_timestamp)});
                            //TODO: Fixare con le giuste date (quando arriveranno da OIC)
                            context.commit('SET_MINMAXDATES', ['maxDate',maxDate]);
                            context.commit('SET_MINMAXDATES', ['minDate',minDate]);
                        }*/
                    }
                    else if(config.url == 'geocode'){
                        context.commit('SET_GEOCODES', response.data.elementi ? response.data.elementi : []);
                    }else if (config.url == 'destinations'){
                        context.commit('SET_DESTINATIONS', response.data.elementi ? response.data.elementi : []);
                    }else if (config.url == 'notify'){
                        var c = response.data;
                        context.commit('SET_MODAL_STATUS', !response.data.common_out ? 'false' : response.data.common_out.return_number == '0' ? 'true' : 'false'); //TODO : attendere altre direttive
                    } else {
                        context.commit('SET_ASSETS', response.data)
                    }

                    $('body').trigger('plp_lp:data', {
                        config: config,
                        response: response
                    });
                },
                error: function (e) {}
            });
        }
    }
})
